/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/react';
import { MediaBorderGapFiller } from '@atlaskit/editor-common/ui';
export var MediaInlineNodeSelector = 'media-inline-node';
export var MediaSingleNodeSelector = 'media-single-node';
var absoluteDivStyles = css({
  position: 'absolute',
  width: '100%',
  height: '100%'
});
var forcedDimensionsStyles = css({
  width: '100%',
  position: 'relative'
});
export var MediaCardWrapper = function MediaCardWrapper(_ref) {
  var dimensions = _ref.dimensions,
    children = _ref.children,
    selected = _ref.selected,
    _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth,
    onContextMenu = _ref.onContextMenu;
  var calculatedBorderWidth = selected && borderWidth > 0 ? borderWidth + 1 : borderWidth;
  return jsx("div", {
    "data-testid": "media-card-wrapper",
    className: "media-card-wrapper",
    style: {
      borderColor: "var(--custom-palette-color)",
      borderWidth: "".concat(calculatedBorderWidth, "px"),
      borderStyle: 'solid',
      borderRadius: "".concat(calculatedBorderWidth * 2, "px")
    }
  }, jsx("div", {
    css: forcedDimensionsStyles,
    style: {
      paddingBottom: "".concat(dimensions.height / dimensions.width * 100, "%")
    },
    onContextMenuCapture: onContextMenu
  }, borderWidth > 0 && jsx(MediaBorderGapFiller, {
    borderColor: "var(--custom-palette-color)"
  }), jsx("div", {
    css: absoluteDivStyles
  }, children)));
};